<script>
import {
  ACAO_SUGESTOES_IA,
  resolveWalletAlerts,
} from '@modules/consolidator/utils/wallet-alerts-catalog/wallet-alerts-catalog'
import {
  isWalletAlertDismissed,
  dismissWalletAlert,
} from '@modules/consolidator/utils/wallet-alerts-dismiss/wallet-alerts-dismiss'
import { apiConsolidatorCotizacao } from '@modules/consolidator/api/apiConsolidatorCotizacao'
import { resolveConsolidationScope } from '@modules/consolidator/utils/consolidation-scope/consolidation-scope'

export default {
  name: 'WalletAlerts',
  props: {
    context: {
      type: Object,
      default: () => ({}),
    },
    // Carteira ainda respondendo. Enquanto for `true`, a acao "Revisar" fica em loading em vez de
    // abrir um painel que nao consegue nomear o ativo nem resolver o alvo da edicao.
    ativosCarregando: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      closedKeys: [],
    }
  },
  computed: {
    idCliente() {
      return this.context.idCliente || ''
    },
    escopoDaDispensa() {
      return resolveConsolidationScope({
        isClient: this.context.isClient,
        idClienteApp: this.idCliente,
      }).scopeKey
    },
    resolvedAlerts() {
      return resolveWalletAlerts(this.context)
    },
    cotizacaoLoading() {
      const getters = (this.$store && this.$store.getters) || {}
      return !!getters['consolidator/cotizacaoLoading']
    },
    visibleAlerts() {
      return this.resolvedAlerts
        .filter((alert) => {
          if (this.closedKeys.includes(alert.dismissKey)) return false
          return !isWalletAlertDismissed({
            alertKey: alert.dismissKey,
            scopeId: this.escopoDaDispensa,
            signature: alert.signature,
            ttlMs: alert.ttlMs,
          })
        })
        .map((alert) => ({
          ...alert,
          actionLoading:
            (alert.actionId === 'cotizar' && this.cotizacaoLoading) ||
            // "Revisar" so age depois que a CARTEIRA respondeu: o painel precisa dos ativos para
            // nomear a sugestao de cadastro e para achar o alvo da edicao. A carteira leva ~23s, e
            // clicar dentro dessa janela abria o painel sem nome e com a edicao inerte.
            (alert.actionId === ACAO_SUGESTOES_IA && this.ativosCarregando),
        }))
    },
  },
  methods: {
    onClose(alert) {
      dismissWalletAlert({
        alertKey: alert.dismissKey,
        scopeId: this.escopoDaDispensa,
        signature: alert.signature,
      })
      if (!this.closedKeys.includes(alert.dismissKey)) {
        this.closedKeys.push(alert.dismissKey)
      }
    },
    onAction(alert) {
      // "cotizar" é autossuficiente (API + snack) e roda aqui mesmo, como no
      // antigo wallet-warnings; as demais ações são responsabilidade da view.
      if (alert.actionId === 'cotizar') {
        this.runCotizacao()
        return
      }
      this.$emit('action', { id: alert.actionId })
    },
    runCotizacao() {
      if (this.context.isFamilyGroup) return
      if (this.context.isClient) return
      if (!this.idCliente) return
      apiConsolidatorCotizacao.run({ id_cliente: this.idCliente })
      this.$showSnack({
        text: 'Cotização iniciada. Os dados serão atualizados em instantes.',
        button: true,
        color: 'success',
      })
    },
  },
}
</script>

<template>
  <div
    v-if="visibleAlerts.length"
    class="wallet-alerts d-flex flex-column az-gap-small"
  >
    <BaseAlert
      v-for="alert in visibleAlerts"
      :key="alert.id"
      :icon="alert.icon"
      :icon-color="alert.iconColor"
    >
      {{ alert.message }}
      <template v-slot:button>
        <BaseButton
          v-if="alert.actionLabel"
          small
          dark
          outline
          min-width="80px"
          class="mx-10"
          :loading="alert.actionLoading"
          @click="onAction(alert)"
        >
          {{ alert.actionLabel }}
        </BaseButton>
        <v-btn
          v-if="alert.closable"
          icon
          small
          aria-label="Fechar alerta"
          @click="onClose(alert)"
        >
          <icon-svg name="close-circle" color="secondary" size="24" />
        </v-btn>
      </template>
    </BaseAlert>
  </div>
</template>
